export const colorArray = ['#5e4eff', '#ef1ccb', '#ff3b8e', '#ff845e', '#ffc34c', '#f9f871']
